import Handlebars from 'handlebars/runtime';

slideshare_object.utils.exports(
  'templates.clipping.clipboards-list-item',
  Handlebars.template({
    1: function (depth0, helpers, partials, data) {
      return 'clip-added';
    },
    compiler: [6, '>= 2.0.0-beta.1'],
    main: function (depth0, helpers, partials, data) {
      var stack1,
        helper,
        alias1 = helpers.helperMissing,
        alias2 = 'function',
        alias3 = this.escapeExpression;

      return (
        '<li class="clipboard-list-item ' +
        ((stack1 = helpers['if'].call(
          depth0,
          depth0 != null ? depth0.checked : depth0,
          {
            name: 'if',
            hash: {},
            fn: this.program(1, data, 0),
            inverse: this.noop,
            data: data,
          }
        )) != null
          ? stack1
          : '') +
        '">\n  <div class="clipboard-item-thumb" style="background-image: url(\'' +
        alias3(
          ((helper =
            (helper =
              helpers.clipboard_image_url ||
              (depth0 != null ? depth0.clipboard_image_url : depth0)) != null
              ? helper
              : alias1),
          typeof helper === alias2
            ? helper.call(depth0, {
                name: 'clipboard_image_url',
                hash: {},
                data: data,
              })
            : helper)
        ) +
        '\');"></div>\n  <div class="clipboard-item-title">' +
        alias3(
          ((helper =
            (helper =
              helpers.title || (depth0 != null ? depth0.title : depth0)) != null
              ? helper
              : alias1),
          typeof helper === alias2
            ? helper.call(depth0, { name: 'title', hash: {}, data: data })
            : helper)
        ) +
        '\n    <span class="svg-icon check">\n' +
        '</span>\n  </div>\n  <button class="clipboard-item-select-btn art-deco small primary" type="button">' +
        alias3(
          this.lambda(
            (stack1 = depth0 != null ? depth0.i18n : depth0) != null
              ? stack1.select
              : stack1,
            depth0
          )
        ) +
        '</button>\n</li>\n'
      );
    },
    usePartial: true,
    useData: true,
  })
);
